var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rooms w1200"},[_c('div',{staticClass:"menus"},[_c('div',{staticClass:"menu"})])])}]

export { render, staticRenderFns }